import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  FormGroup,
  Input,
} from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { post, put, get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { ImageDrop } from "quill-image-drop-module";
import ReactQuill, { Quill } from "react-quill";
import QuillResizeImage from "quill-resize-image";
import Pass from "../../../components/Common/Pass";
import passDesign1 from "../../../../src/assets/peach.svg";
import passDesign2 from "../../../../src/assets/green.svg";
import passDesign3 from "../../../../src/assets/purple.svg";
import "react-quill/dist/quill.snow.css";
import { current } from "@reduxjs/toolkit";
Quill.register("modules/resize", QuillResizeImage);
Quill.register("modules/imageDrop", ImageDrop);

export default function AddOrUpdatePass() {
  const [isUpdate, setIsUpdate] = useState(false);
  {
    isUpdate
      ? (document.title = "Edit Pass | Elevated - Admin Dashboard")
      : (document.title = "Add Pass | Elevated - Admin Dashboard");
  }
  const [gymId, setGymId] = useState("");
  const [gymName, setGymName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [passId, setPassId] = useState(null);
  const { appRole, id } = useSelector((state) => state.auth.currentUser);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const gymIdFromParams = searchParams.get("gymId");
    const passIdFromParams = searchParams.get("passId");

    setGymId(gymIdFromParams);
    setPassId(passIdFromParams);

    if (passIdFromParams) {
      setIsUpdate(true);
      fetchPassDetails(passIdFromParams);
    }
  }, [location.search]);
  const [editorState, setEditorState] = useState();
  const handleEditorChange = (value, setFieldValue) => {
    setEditorState(value);

    // Convert to raw content and HTML (optional since ReactQuill works directly with HTML)
    const content = value; // ReactQuill content is already HTML
    const rawContent = JSON.stringify({ htmlContent: content });

    setFieldValue("content", rawContent); // Set the field value as required
  };
  const fetchPassDetails = async (id) => {
    try {
      const response = await get(`${endpoints.pass}/${id}`);
      if (response?.data) {
        formik.setValues({
          passName: response?.data?.data.name || "",
          passType: response?.data?.data.duration || "",
          passPrice: response?.data?.data.price || "",
          content: JSON.stringify(response?.data?.data.content) || "",
        });
        setEditorState(response?.data?.data.content?.htmlContent);
      } else {
        console.error("No data found for the pass ID");
      }
    } catch (error) {
      console.error("Error fetching pass details:", error);
    }
  };
  const formik = useFormik({
    initialValues: {
      passName: "",
      passType: "",
      passPrice: "",
      content: "",
    },
    validationSchema: Yup.object({
      passName: Yup.string()
        .required("Name is required")
        .min(2, "Name must be at least 2 characters")
        .max(50, "Name must be less than 50 characters"),

      passType: Yup.string().required("Pass type is required"),
      passPrice: Yup.number()
        .required("Price is required")
        .positive("Price must be a positive number")
        .min(0.01, "Price must be at least 0.01")
        .typeError("Price must be a valid number"),
      content: Yup.string().required("Please provide content."),
    }),
    onSubmit: async (values) => {
      const passData = {
        name: values.passName,
        duration: values.passType,
        price: parseFloat(values.passPrice),
        coinPrice: parseFloat(values.passPrice * 0.9) * 10,
        content: values.content,
        gymId: gymId ? gymId : seletedGymId,
      };

      try {
        setIsSubmitting(true);
        if (isUpdate) {
          const resp = await put(`${endpoints.pass}/${passId}`, passData);

          if (resp.data.success) {
            toast.success("Pass Updated Successfully", {
              position: "bottom-center",
              theme: "colored",
              transition: Bounce,
            });
            navigate(`/list-passes?gymId=${gymId}`);
          } else {
            toast.error("Something went wrong!", {
              position: "bottom-center",
              theme: "colored",
              transition: Bounce,
            });
          }
        } else {
          const resp = await post(endpoints.pass, passData);
          if (resp.data.success) {
            toast.success("Pass Added Successfully", {
              position: "bottom-center",
              theme: "colored",
              transition: Bounce,
            });
            navigate(`/list-passes?gymId=${gymId ? gymId : seletedGymId}`);
          } else {
            toast.error("Something went wrong!", {
              position: "bottom-center",
              theme: "colored",
              transition: Bounce,
            });
          }
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again.", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      } finally {
        setIsSubmitting(false);
      }
    },
  });
  const [selectedGym, setSelectedGym] = useState("");
  const [gymData, setGymData] = useState([]);
  const [seletedGymId, setSeletedGymId] = useState("");
  const gymIds = async () => {
    const resp = await get(`${endpoints.gym}/admin?userId=${id}&limit=50`);
    if (resp?.data?.success) {
      setGymData(resp.data.data);
      console.log(resp.data.data);
      setSelectedGym(resp.data.data[0]?.name);
      setSeletedGymId(resp.data.data[0]?._id);
    }
  };

  useEffect(() => {
    if (appRole == "gymOwner" || appRole == "gymStaff") {
      gymIds();
    }
  }, []);

  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col md={12}>
            <Card className="rounded-4" style={{ borderRadius: "12px" }}>
              <Col md={12} style={{ width: "98%" }}>
                <CardBody class="">
                  <h2 className="ff-sora font-size-20 fw-bold">
                    {isUpdate ? "Update Pass" : "Add New Pass"}
                  </h2>

                  <form className="" onSubmit={formik.handleSubmit}>
                    <div
                      className="w-100 "
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignContent: "flex-start",
                        flexWrap: "wrap-reverse",
                      }}
                    >
                      <div className="col-12 col-md-6">
                        <FormGroup>
                          <input
                            type="text"
                            placeholder="Pass name"
                            className={`rounded-5 bg-light ff-sora font-size-16 px-4 fw-normal custom-placeholder form-control ${
                              formik.touched.passName && formik.errors.passName
                                ? "is-invalid"
                                : ""
                            }`}
                            name="passName"
                            style={{
                              width: "100%",
                              maxWidth: "420px",
                              height: "56px",
                              border: "none",
                            }}
                            value={formik.values.passName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.passName && formik.errors.passName ? (
                            <div className="invalid-feedback text-danger font-size-12 ff-sora fw-normal my-1">
                              {formik.errors.passName}
                            </div>
                          ) : null}
                        </FormGroup>
                        {(appRole == "gymOwner" || appRole == "gymStaff") && (
                          <FormGroup>
                            <Input
                              disabled={isUpdate}
                              name="passType"
                              style={{
                                width: "100%",
                                maxWidth: "420px",
                                height: "56px",
                                border: "none",
                              }}
                              className={`rounded-5 bg-light ff-sora font-size-16 px-4 fw-normal form-control `}
                              type="select"
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                setSeletedGymId(selectedValue);

                                const selectedGym = gymData.find(
                                  (gym) => gym._id === selectedValue
                                );

                                if (selectedGym) {
                                  setGymName(selectedGym.name);
                                }
                              }}
                            >
                              {gymData.map((item, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={item._id}
                                    selected={gymId == item._id ? true : false}
                                  >
                                    {item.name}

                                    <small style={{ fontSize: "9px" }}>
                                      (Selected GYM)
                                    </small>
                                  </option>
                                );
                              })}
                            </Input>
                          </FormGroup>
                        )}
                        <FormGroup>
                          <Input
                            name="passType"
                            style={{
                              width: "100%",
                              maxWidth: "420px",
                              height: "56px",
                              border: "none",
                            }}
                            className={`rounded-5 bg-light ff-sora font-size-16 px-4 fw-normal form-control ${
                              formik.touched.passType && formik.errors.passType
                                ? "is-invalid"
                                : ""
                            }`}
                            type="select"
                            value={formik.values.passType}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          >
                            <option className="light-black" value="">
                              Select Pass Type
                            </option>
                            <option value="oneday">One Day</option>
                            <option value="oneweek">One Week</option>
                            <option value="onemonth">One Month</option>
                          </Input>
                          {formik.touched.passType && formik.errors.passType ? (
                            <div className="invalid-feedback text-danger font-size-12 ff-sora fw-normal my-1">
                              {formik.errors.passType}
                            </div>
                          ) : null}
                        </FormGroup>
                        <FormGroup>
                          <input
                            type="number"
                            placeholder="Pass price"
                            className={`rounded-5 bg-light ff-sora font-size-16 px-4 fw-normal custom-placeholder form-control ${
                              formik.touched.passPrice &&
                              formik.errors.passPrice
                                ? "is-invalid"
                                : ""
                            }`}
                            name="passPrice"
                            value={formik.values.passPrice}
                            onChange={formik.handleChange}
                            style={{
                              width: "100%",
                              maxWidth: "420px",
                              height: "56px",
                              border: "none",
                            }}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.passPrice &&
                          formik.errors.passPrice ? (
                            <div className="invalid-feedback text-danger font-size-12 ff-sora fw-normal my-1">
                              {formik.errors.passPrice}
                            </div>
                          ) : null}
                        </FormGroup>
                      </div>
                      <div className="my-3 col-12 col-md-6 ps-md-2 ps-xl-0">
                        <Pass
                          code={
                            formik.values.passName +
                            formik.values.passPrice +
                            formik.values.passType +
                            gymName
                          }
                          name={formik.values.passName}
                          price={formik.values.passPrice * 10}
                          duration={formik.values.passType}
                          filter={
                            formik.values.passType === "oneday"
                              ? passDesign1
                              : formik.values.passType === "oneweek"
                              ? passDesign2
                              : formik.values.passType === "onemonth"
                              ? passDesign3
                              : null
                          }
                          address={gymName}
                          createdAt={new Date()}
                        />
                      </div>
                    </div>
                    <FormGroup>
                      {/* <Editor
                          editorState={editorState}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(state) =>
                            handleEditorChange(state, setFieldValue)
                          }
                        /> */}
                      <h5 className="ff-sora font-size-18 fw-medium">
                        User Acknowledgement Content{" "}
                      </h5>
                      <ReactQuill
                        value={editorState}
                        onChange={(state) => {
                          handleEditorChange(state, formik.setFieldValue);
                        }}
                        theme="snow"
                        modules={{
                          toolbar: [
                            [{ header: "1" }, { header: "2" }, { font: [] }],
                            [{ list: "ordered" }, { list: "bullet" }],
                            ["bold", "italic", "underline", "strike"],
                            [{ color: [] }, { background: [] }],
                            [{ align: [] }],
                            ["link"],
                            ["clean"],
                            ["image"],
                          ],
                          imageDrop: true,
                          resize: {
                            locale: {},
                          },
                          clipboard: true,
                        }}
                        formats={{ formats: ["image"] }}
                        className="custom-editor"
                      />
                      {formik.errors?.content && formik.touched?.content && (
                        <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                          {formik.errors?.content}
                        </div>
                      )}
                    </FormGroup>
                    <div
                      className="d-flex justify-content-end mx-4"
                      style={{ width: "100%" }}
                    >
                      <Button
                        type="submit"
                        className="me-2 rounded-pill"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          isUpdate ? (
                            <span>Updating...</span>
                          ) : (
                            <span>Adding...</span>
                          )
                        ) : isUpdate ? (
                          "Update Passes"
                        ) : (
                          "Add Passes"
                        )}
                      </Button>
                      <Button
                        color="white"
                        className="rounded-pill1 ms-2"
                        style={{
                          transition: "none",
                        }}
                        onClick={() => {
                          formik.resetForm();
                          navigate(`/list-passes?gymId=${gymId}`);
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </form>
                </CardBody>
              </Col>
            </Card>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                height: "60px",
                position: "sticky",
                bottom: "0",
                zIndex: "10",
              }}
            ></div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
